



























import { WithErrorModal } from '@/components/organisms/dialog/error-dialog/with-error-modal'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import HeaderBottomUserNotification from '@ajax/vue/components/templates/HeaderBottomUserNotification.vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    HeaderBottomUserNotification,
    SpaErrorDialog,
  },
})
export default class LoginPageWithTab extends Mixins<WithErrorModal>(WithErrorModal) {
  @Prop({ default: '/s/mypage' })
  /**
   * @see LoginPageProps.next
   */
  readonly next: string

  @Prop({ default: '/signup' })
  /**
   * @see LoginPageProps.signupLink
   */
  readonly signupLink: string

  @Prop({ default: 'ログイン' })
  /**
   * @see LoginPageProps.title
   */
  readonly title: string
}
